<template>
  <section>
    <HeroSection headName="Confirmar Envio" :searchBar="false" :addButton="false">
    </HeroSection>

    <div class="container">

      <form class="form">
        <div class="form__box" v-if="loading">
          <h2 class="form__name">
            <DataLoading rows="1" height="50px" />
          </h2>

          <div class="form__content">
            <DataLoading rows="4" height="80px" />
          </div>
        </div>

        <div class="form__wrap" v-if="!loading">
          <div class="form__box">
            <h2 class="form__name">
              Confirmação
            </h2>

            <div class="form__content">
              <div class="form__row" style="font-size: 18px">
                Confirmar envio neste momento?
              </div>
            </div>
          </div>

          <FormBottom :data="button" @submit="submit()" />

        </div>
      </form>
    </div>
  </section>
</template>

<script>

import HeroSection from '@components/_partials/HeroSection.vue';
import DataLoading from '@components/_partials/DataLoading.vue';
import FormBottom from '@components/_form/FormBottom.vue';
import { baseUrl, padVal, brDate, docMask, phoneMask, brMoney, globalDate } from '@helpers/functions';
import { typeServices, schedulePeriod, isActive } from '@helpers/constants'
import envio from '@services/envio';

export default {
  components: {
    HeroSection,
    DataLoading,
    FormBottom,

  },
  data() {
    return {
      loading: false,
      button: { spinner: false, label: 'Enviar E-mails', color: 'primary' },
      model: { sender: {}, list: {} },
    }
  },
  methods: {
    baseUrl,
    brDate,
    padVal,
    docMask,
    phoneMask,
    brMoney,
    globalDate,
    typeServices,
    schedulePeriod,
    isActive,
    loadForm: function(_id) {
      const _this = this;
      _this.loading = true;

      envio.show(_id).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.model = res.data;
          _this.loading = false;
        }
      });
    },
    submit() {
      const _this = this;
      const _id = _this.hasIdx();
      const button = _this.button;

      _this.button = {
        spinner: true,
        label: 'Salvando...',
        color: 'warning'
      }
      envio.send(_id).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.button = {
            spinner: false,
            label: 'Salvo com sucesso!',
            color: 'success'
          }

          setTimeout(() => this.$router.push('/envios'), 1000);
        }

        if(typeof res === 'undefined' || !res.success) {
          _this.button = {
            spinner: false,
            label: 'Houve um erro ao processar.',
            color: 'danger'
          }
          setTimeout(() => _this.button = button, 3000);
        }
      })

    },
    hasIdx() {
      const _this = this;
      return _this.$route.params.id ? _this.$route.params.id : null;
    }
  },
  mounted(){
    const _id = this.hasIdx();
    if(_id) this.loadForm(_id);
  }
};

</script>
